<div class="table-responsive" *ngIf="siparisler">
  <table class="table card-table table-vcenter text-nowrap datatable">
    <thead>
      <tr>
        <th class="w-1">Talep No</th>
        <th>Talep Tarihi</th>
        <th>Şube Adı</th>
        <th>Talep Türü</th>
        <th>Ürün Grubu</th>
        <th>Firma</th>
        <th>Onay Durum</th>
        <th>Talep Oluşturan</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let s of siparisler">
        <tr
          [class]="(s.durum === DURUM_ONAY_BEKLIYOR && s.siparisOnaySeviye?.kullaniciGrup?.id === userGrupId) ? 'bg-orange text-white' : ''">
          <!-- <td><span class="text-muted">{{s.id}}</span></td> -->
          <td>{{s.talep?.talepNo}}</td>
          <td>{{s.olusturmaTarihiText}}</td>
          <td>{{s.talep?.sube?.isim}}</td>
          <td>{{s.talep?.talepTur?.isim}}</td>
          <td>{{s.talep?.urunGrup?.isim}}</td>
          <td>{{s.cari?.firmaUnvani}}</td>
          <td [class]="pIsSiparis && s.toplamIrsaliyeMiktar > 0 && s.toplamSiparisMiktar - s.toplamIrsaliyeMiktar > 0 ? 'alert alert-warning' : ''">{{s.durumText}}
            <svg *ngIf="pIsSiparis && s.toplamIrsaliyeMiktar > 0 && s.toplamSiparisMiktar - s.toplamIrsaliyeMiktar > 0" xmlns="http://www.w3.org/2000/svg" class="icon" width="24"
              height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
              stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </td>
          <td>{{s.talep?.kullanici?.adSoyad}}</td>
          <td class="text-right">
            <div class="btn btn-sm btn-primary" (click)="incele(s)">İncele</div>
            <div
              *ngIf="s.durum === DURUM_ONAYLANDI && pIsSiparis && (userGrupId === 1 || userGrupId === 5 || userGrupId === 6)"
              class="btn btn-sm btn-danger ml-2" (click)="iptalEt(s.id)">İptal Et
            </div>
            <!-- <div *ngIf="s.durum === DURUM_ONAY_BEKLIYOR" class="btn btn-sm btn-success ml-3"
                 (click)="onayla(s.id,DURUM_ONAYLANDI)">Onayla
            </div>
            <div *ngIf="s.durum === DURUM_ONAY_BEKLIYOR" class="btn btn-sm btn-danger ml-3"
                 (click)="onayla(s.id,DURUM_REDDEDILDI)">Reddet
            </div> -->
            <!-- <div *ngIf="s.durum === DURUM_ONAYLANDI" class="btn btn-sm btn-outline-success ml-3" (click)="irsaliyeGir(s)">
              İrsaliye Gir
            </div> -->
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>